import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { DropdownActionMenu } from '../../../types/shared-types';
import { ActionPermissionService } from 'src/app/features/user/services/action-permission.service';

@Component({
  selector: 'app-ngb-dropdown-action',
  template: `
    <div ngbDropdown #primary="ngbDropdown" container="body">

      <button type="button" class="btn btn-light-primary btn-sm dropdown-toggle dropdown-remove" role="button" data-bs-toggle="dropdown" aria-expanded="false" ngbDropdownToggle>
        <i class="feather icon-more-vertical"></i>
      </button>

      <div ngbDropdownMenu aria-labelledby="dropdownManual">

        <ng-container *ngIf="dropdownItems else optionTemplate">
          <button *ngFor="let item of dropdownItems" class="w-100 m-0 py-2" ngbDropdownItem (click)="menuClick(item)">
          {{ item }}
          </button>
        </ng-container>

        <ng-template #optionTemplate>
          <ng-container *ngFor="let item of options">
              <button class="w-100 m-0 py-2" ngbDropdownItem (click)="menuClick(item.value)">
              {{ item.name }}
              </button>
          </ng-container>
        </ng-template>

      </div>
    </div>
  `,
})
export class NgbDropdownActionComponent implements OnInit {

  @Input() dropdownItems: any;
  @Input() dropdownOptions: DropdownActionMenu[] = []
  @Output() menuClickEvent = new EventEmitter();
  options: DropdownActionMenu[] = []

  constructor(
    private actionPermissionService: ActionPermissionService
  ) {

  }

  ngOnInit() {
    this.updateDropdownOptionsVisibility();
  }

  private updateDropdownOptionsVisibility(): void {
    const options = [...this.dropdownOptions].map((option: DropdownActionMenu) => (
      {
        ...option,
        visible: this.actionPermissionService.isActionAllowed(option.permission)
      }
    ));
    this.options = options.filter(option => option.visible === true);
  }

  menuClick(item: string) {
    this.menuClickEvent.emit(item)
  }
}
